import { IncomingMessage } from 'http';

import { fechFromBPartsApi } from '../utils';

const fetchLastVehicles = async (
  {
    locale,
    carIdentifier,
    partIdentifier,
  }: {
    locale: string;
    partIdentifier?: string;
    carIdentifier: string;
  },
  req?: IncomingMessage
) => {
  const query = [];
  if (carIdentifier) {
    query.push(`car_identifier=${encodeURI(carIdentifier)}`);
  }

  if (partIdentifier) {
    query.push(`part_identifier=${encodeURI(partIdentifier)}`);
  }

  const data = await fechFromBPartsApi(
    `/${locale}/shop/vehicles/last_entries?${query.join('&')}`,
    {
      credentials: 'include',
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
    }
  );

  if (data.ok) {
    return data.json();
  } else {
    return null;
  }
};

export default fetchLastVehicles;
